
import React, {
  useEffect, // Add to imports
  useRef, // Add to imports
  useState
} from "react";

// Material ui
import {
  Box,
  Container,
  Grid,
  IconButton
} from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import MicIcon from '@mui/icons-material/Mic';
import MicRecorder from 'mic-recorder-to-mp3';
import './App.css';
// import topics_en from './topics_en.json';
// import topics_cn from './topics_cn.json';
// import topics_en_vn from './topics_en_vn.json';
// import topics_cn_vn from './topics_cn_vn.json';
import {
  ResponseFormatToggle,
} from './UtilsMisc'
// import { useLocation } from 'react-router-dom';

export const AudioControls = ({ learnLanguage, topics,nativeLanguage, defaultSpeed, selectedLevel, setSelectedLevel, selectedTopic, setSelectedTopic, refMessages, setRefMessages, isRecording, setIsRecording, isAudioResponse, setIsAudioResponse, filterMessageObjects, messages, setMessages, handleSendMessage, message, setMessage, thinking, setThinking }) => {
  const [recorder, setRecorder] = useState(null);
  const [timer, setTimer] = useState(null); // to set max recording time
  const stopRecordingButtonRef = useRef(null); // to identify the button for stop recording

// const location = useLocation();
  // const pathSegments = location.pathname.split('/');
  // const current_path = pathSegments[1]; // "chat_cn"

  // let topics;
  // if (learnLanguage === 'Chinese'){ 
  //     if (nativeLanguage === 'Vietnamese') {
  //         topics = topics_cn_vn;
  //     } else {
  //         topics = topics_cn;
  //     }
  // } else {
  //     if (nativeLanguage === 'Vietnamese') {
  //         topics = topics_en_vn;
  //     } else {
  //         topics = topics_en;
  //     }
  // }
  // if (current_path === 'chat_cn') {
  //     use_topics = topics_cn;
  // } else {
  //     use_topics = topics_en;
  // }

  // Filter topics based on the selected level
  // console.log('UtilsAudio learnLanguage' + learnLanguage);
  // console.log('UtilsAudio selectedLevel' + selectedLevel);
  
  useEffect(() => {
      setRecorder(new MicRecorder({ bitRate: 128 }));

  }, []);


  const startRecording = async () => {
      try {
          await recorder.start();
          setIsRecording(true);

          setTimer(
              setTimeout(() => {
                  stopRecordingButtonRef.current.click();
              }, 20000) // Set the maximum recording time (in milliseconds)
          );

      } catch (e) {
          console.error(e);
          alert(e);
      }
  }

  const stopRecording = async () => {
      //console.log('stopRecording');
      if (!recorder || !isRecording) return;
      clearTimeout(timer); // Clear the timer if the "Stop Recording" button is clicked manually
      try {
          const [buffer, blob] = await recorder.stop().getMp3();
          const audioFile = new File(buffer, "voice-message.mp3", {
              type: blob.type,
              lastModified: Date.now(),
          });
          setIsRecording(false);
          if (!audioFile) {
              //("No audio file to upload");
              return;
          }

          try {

              const reader = new FileReader();
              reader.onloadend = async () => {
                  const base64Audio = reader.result;
                  handleSendMessage("3","", base64Audio );
              };
              reader.readAsDataURL(audioFile);

          } catch (error) {
              console.error("Error uploading audio file:", error);
              alert(error)
          }
      } catch (e) {
          console.error(e);
          alert(e)
      }
  };

  const handleLevelChange = (event) => {
      //console.log('change level');
      setSelectedLevel(event.target.value);
  };

  const handleTopicChange = (event) => {
      //console.log('change topic');
      setSelectedTopic(event.target.value);
// refMessages
      // let updatedRefMessages = [...refMessages];
      // updatedRefMessages[0] = {
      //   ...updatedRefMessages[0],
      //   content: `Chat with me in English, about ${event.target.value}`,
      // };
      // setRefMessages(updatedRefMessages);
  };
  // getTopics(learnLanguage,setTopics);
  if(JSON.stringify(topics) === "{}"){
      return  <div>Loading...</div>;
  }    
  
  // console.log("use_topics:   " + JSON.stringify(topics));
  const filteredTopics = selectedLevel ? Object.keys(topics[selectedLevel][1]) : [];

  return (
      <Container>
          <Box sx={{ width: "113%", mt: 1, mb: -.5 }}>
              <Grid container spacing={0} sx={{ mt: 1, mb: 0 }}>

                  <Grid item xs={2} md sx={{  marginLeft: -1, marginRight:-1.5 }} >
                      <ResponseFormatToggle isAudioResponse={isAudioResponse} setIsAudioResponse={setIsAudioResponse} />
                  </Grid>
                  <Grid item xs={2} md sx={{ zIndex: 1, marginTop: 1, marginBottom: 1, marginLeft: 0, marginRight: 1 }}>
  <select id="select-level" value={selectedLevel} onChange={handleLevelChange}>
      {/* <option value="">等级</option> */}
      {Object.keys(topics).map((level) => (
          <option key={level} value={level}>{topics[level][0]}</option>
      ))}
  </select>
</Grid>
<Grid item xs={4} md sx={{ zIndex: 1, marginTop: 1, marginBottom: 1, marginLeft: 1.5, marginRight: 2 }}>
  <select id="select-topic" value={selectedTopic} onChange={handleTopicChange} style={{ maxWidth: "150px" }}>
      {/* <option value="">话题</option> */}
      {filteredTopics.map((topic) => (
          <option key={topic} value={topic}>{topic}</option>
      ))}
  </select>
</Grid>
                  {!isRecording ? (
                      <Grid item xs={2} md sx={{zIndex: 1, marginLeft: 4 }}>
                          <IconButton
                              color="primary"
                              aria-label="start recording"
                              onClick={startRecording}
                              disabled={isRecording || thinking}
                          >
                              {/* {thinking ? '...' : <MicIcon />} */}
                              {<MicIcon />}
                          </IconButton>
                      </Grid>
                  ) : (
                      <Grid item xs={2} md sx={{zIndex: 1, marginLeft: 4 }}>
                          <IconButton
                              color="secondary"
                              aria-label="stop recording"
                              onClick={stopRecording}
                              disabled={!isRecording || thinking}
                              ref={stopRecordingButtonRef}
                          >
                              {/* {thinking ? '...' : <FiberManualRecordIcon />} */}
                              {<FiberManualRecordIcon />}
                          </IconButton>
                      </Grid>
                  )
                  }
              </Grid>
          </Box>
      </Container>

  )
}
